import React from "react";
import { _getBaseUrl } from "../utils/helper";

const Pagination = ({ totalPages, page, ...props }) => {
  const isPrevBtnDisabled = page <= 1;
  const isNextBtnDisabled = page >= totalPages;

  return totalPages <= 1 ? null : (
    <div className="pagination">
      <button
        className={`btn-pager btn-pager-prev ${
          isPrevBtnDisabled ? "disabled" : ""
        }`}
        disabled={isPrevBtnDisabled}
        onClick={() => props.setPage(page - 1)}
      >
        <img
          src={_getBaseUrl(
            "src/assets/icons/icon-chevron-right-white.svg",
            true
          )}
          alt="previous arrow"
        />
      </button>
      {!props.hidePageIndex && (
        <div className="page-index">{`${page} of ${totalPages}`}</div>
      )}
      <button
        className={`btn-pager btn-pager-next ${
          isNextBtnDisabled ? "disabled" : ""
        }`}
        disabled={isNextBtnDisabled}
        onClick={() => props.setPage(page + 1)}
      >
        <img
          src={_getBaseUrl(
            "src/assets/icons/icon-chevron-right-white.svg",
            true
          )}
          alt="next arrow"
        />
      </button>
    </div>
  );
};

export default Pagination;
